import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core'
import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
import {
  faBriefcase,
  faArrowRight,
  faCommentAlt,
  faColumns,
  faTools,
  faHardHat,
  faUsers,
  faStore,
  faSignOutAlt,
  faListUl
} from '@fortawesome/free-solid-svg-icons'

import { Router } from '@angular/router'
import { AuthService } from 'src/app/features/auth/auth.service'
import { MatDrawer } from "@angular/material/sidenav";
import { BaseComponentComponent } from "../../base-component/base-component.component";
import { ACCESS_CONTROL_TYPES } from "../../../core/roles"
import { getItemInLocalStorage, setItemInLocalStorage } from '../../utils/localStorageFunctions';
import { AdminService } from 'src/app/features/admin/admin.service';
import { AccountTypeService } from '../../../core/services/account-type.service';
import { firstValueFrom } from 'rxjs';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent extends BaseComponentComponent implements OnInit, OnDestroy {
  faBriefcase = faBriefcase
  faArrowRight = faArrowRight
  faCommentAlt = faCommentAlt
  faColumns = faColumns
  faTools = faTools
  faUsers = faUsers
  faStore = faStore
  faHardHat = faHardHat
  faSignOut = faSignOutAlt
  faServiceOrder = faListUl

  accessControl = ACCESS_CONTROL_TYPES
  logoUrl = '';
  isOwnerAccount: boolean = false;
  accountName: string = '';
  userProfile: any = null;
  isOonEnabled: boolean = false;

  constructor(
    private readonly router: Router,
    public authService: AuthService,
    private _adminService: AdminService,
    private _accountTypeService: AccountTypeService,
    private cdr: ChangeDetectorRef
  ) {
    super()
  }

  @ViewChild('drawer')
  private matDrawer!: MatDrawer

  async ngOnInit() {
    const accountId = this.authService.accountId;
    this.isOwnerAccount = this.authService.isOwnerAccess();

    // Carregar informações da conta primeiro
    this.loadAccountInfo();
    this.isOonEnabled = this._accountTypeService.isOonIntegrationEnabled();

    // Carregar logo personalizada
    if (accountId) {
      const accountLogoKey = `account_logo_${accountId}`;
      const cachedLogo = getItemInLocalStorage(accountLogoKey);

      if (cachedLogo) {
        this.logoUrl = cachedLogo;
      } else {
        try {
          const res = await firstValueFrom(this._adminService.getLogo(accountId));
          if (res && res.logo_base64) {
            this.logoUrl = res.logo_base64;
            setItemInLocalStorage(accountLogoKey, this.logoUrl);
          }
        } catch (error: any) {
          // Ignorar erro 404 silenciosamente (logo não existe)
          if (error?.status !== 404) {
            console.warn('Logo personalizada não encontrada ou erro ao carregar:', error);
          }
          // Manter logoUrl vazio para usar o logo padrão
          this.logoUrl = '';
        }
      }
    }

    // Listener para atualizar o logo quando ele for modificado
    window.addEventListener('logoUpdated', () => {
      this.reloadLogo();
    });
  }

  get currentUrl(): string {
    return this.router.url || '';
  }

  // Escritório ficou com Meus Documentos e Propostas de Seguro
  isEscritorioActive(): boolean {
    const u = this.currentUrl;
    return u.startsWith('/documentos') || (this.isOwnerAccount && u.startsWith('/mirror-policies'));
  }

  isEscritorioPanelActive(): boolean {
    return this.isEscritorioActive();
  }

  // Integrações Seguradora: apólices e sinistros da OON
  isSeguradoraActive(): boolean {
    const u = this.currentUrl;
    return this.isOonEnabled && (u.startsWith('/oon-policies') || u.startsWith('/oon-sinisters'));
  }

  isCadastroActive(): boolean {
    const u = this.currentUrl;
    return u.startsWith('/users-management') || u.startsWith('/customers') || u.startsWith('/products') || u.startsWith('/vehicles');
  }

  isCadastroPanelActive(): boolean {
    return this.isCadastroActive();
  }

  isVehiclesActive(): boolean {
    const u = this.currentUrl;
    return u.startsWith('/vehicles') && !u.startsWith('/vehicles/links') && !u.startsWith('/vehicles/seguros');
  }





  loadAccountInfo(): void {
    const accessedAccountName = this.authService.accountName;

    if (accessedAccountName) {
      this.accountName = accessedAccountName;
    } else if (this.isOwnerAccount) {
      this.accountName = 'Owner';
    } else {
      this.userProfile = this.authService.getPerfil();
      if (this.userProfile && this.userProfile.nome) {
        this.accountName = this.userProfile.nome;
      } else {
        this.accountName = 'Carregando...';
      }
    }

    this._accountTypeService.getOonIntegrationEnabled().subscribe((enabled) => {
      this.isOonEnabled = enabled;
      this.cdr.detectChanges();
    });
  }


  handleRedirectTo(component: string) {
    this.router.navigateByUrl(component)
  }

  toggleSideBar() {

    this.matDrawer.toggle();


  }

  goToHomePage(): void {

    this.router.navigateByUrl('/dashboard-inicial')

  }

  handleLogout() {
    this.authService.logout()
  }

  /**
   * Método para recarregar o logo (útil quando o logo é alterado)
   */
  async reloadLogo(): Promise<void> {
    const accountId = this.authService.accountId;

    if (accountId) {
      const accountLogoKey = `account_logo_${accountId}`;
      
      // Limpar cache do logo específico da conta
      localStorage.removeItem(accountLogoKey);
      
      try {
        const res = await firstValueFrom(this._adminService.getLogo(accountId));
        if (res && res.logo_base64) {
          this.logoUrl = res.logo_base64;
          setItemInLocalStorage(accountLogoKey, this.logoUrl);
        } else {
          this.logoUrl = '';
        }
      } catch (error) {
        console.warn('Logo personalizada não encontrada:', error);
        this.logoUrl = '';
      }
    }
  }

  ngOnDestroy(): void {
    // Remover listener quando o componente for destruído
    window.removeEventListener('logoUpdated', () => {
      this.reloadLogo();
    });
  }
}
